import { paginaRecordada, recordarPagina, olvidarPagina, fijarCampusPagina } from "../../../../utils/paginaRecordada";
import React, {
    useEffect,
    useRef,
    useState
} from "react";

import { useLocation, useNavigate } from "react-router-dom";
import {
    useDispatch,
    useSelector
} from "react-redux";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { sprintf } from "sprintf-js";
import {
    OverlayTrigger,
    Tooltip
} from "react-bootstrap";

import { cursoCorto } from '../../../../utils/cursoCorto';
import Constants,
{
    FILTER_TYPES,
    FINANCES_MODALS,
    invoiceStatus,
    OPERATORS
} from "../../../../constants";
import {
    RootState,
    enableIdleLockSwitch,
    disableIdleLockSwitch,
    displayNotice,
    AppDispatch,
    setCurrentUserCampus,
    setCurrentUserCampusId
} from "../../../../globals";
import HttpManager from "../../../../services/HttpManager";
import {
    handleSelectedInvoice,
    setIsCancelPayment,
    setIsNewInvoice,
    setIsPartialPayment,
    setModalContent,
    setRefundItems,
    setSelectedCredit,
    setSelectedInvoice,
    setSelectedPayment,
    setShowModal,
    setStudentData,
    setTotalToPaid
} from "../../../../redux/reducers/invoicesReducer";
import { setCurrentCampus, setCurrentCampusId, setPermissions, UserState } from "../../../../redux/reducers/sessionReducer";
import { setPaymentMethods } from "../../../../redux/reducers/catalogReducer";
import { handleSelectedPayment } from "../../../../redux/reducers/paymentsReducer";
import { Column } from "../../../../components/commonTable";
import InvoiceView from "./invoiceView";
import { handleSelectedCredit } from "../../../../redux/reducers/creditsReducer";
import { getErrorMessage } from "../../../../common";
import { styles } from "./style";
import ButtonComponent from "../../../../components/buttons/button";

const InvoiceController = (props: any, route: any) => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const location = useLocation();
    const pagesSize: number[] = [100, 50, 20, 10];   // 100 por página por defecto (Esteban, 2026-09-11)
    const http = HttpManager.getInstance();
    const idleLocked: boolean = useSelector((state: RootState) => state.idleLockSwitch.value);
    const userData: UserState | null = useSelector((state: RootState) => state.rootReducer.sessionState.user);
    const currentRole: any = useSelector((state: RootState) => state.rootReducer.sessionState.currentRole);
    const currentCampus: any = useSelector((state: RootState) => state.rootReducer.sessionState.currentCampus);
    const campuses: any[] = useSelector((state: RootState) => state.rootReducer.catalog.campuses);
    const studentData: any = useSelector((state: RootState) => state.rootReducer.invoices.studentData);
    const selectedInvoice: any = useSelector((state: RootState) => state.rootReducer.invoices.selectedInvoice);
    const selectedPayment: any = useSelector((state: RootState) => state.rootReducer.invoices.selectedPayment);
    const isPartialPayment: boolean = useSelector((state: RootState) => state.rootReducer.invoices.isPartialPayment);
    const isNewInvoice: boolean = useSelector((state: RootState) => state.rootReducer.invoices.isNewInvoice);
    const invoiceStatuses: [] = useSelector((state: RootState) => state.rootReducer.catalog.invoiceStatuses);
    const [dateRange, setDateRange] = useState<{ start: Date | null; end: Date | null }>({
        start: null,
        end: null,
    });
    const [total, setTotal] = useState<{ option: string; quantity: number }>({
        option: "",
        quantity: 0,
    });
    const [paidAmount, setPaidAmount] = useState<{ option: string; quantity: number }>({
        option: "",
        quantity: 0,
    });
    const [pendingAmount, setPendingAmount] = useState<{ option: string; quantity: number }>({
        option: "",
        quantity: 0,
    });
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [invoices, setInvoices] = useState<any>(null);
    const [pages, setPages] = useState<any>(null);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const paginaCargadaRef = useRef<boolean>(false);
    const [itemsPerPage, setItemsPerPage] = useState<number>(pagesSize[0]);
    const [itemCount, setItemCount] = useState<any>(null);
    const [searchValue, setSearchValue] = useState<string>("");
    const [filters, setFilters] = useState<{ [key: string]: any }>({});
    const filtersUpdatedRef = useRef(false);

    const onChangeSearch = (newSearchValue: string) => {
        setSearchValue(newSearchValue);
    }

    const onClickSearch = () => {
        setFilters({ ...filters, search: searchValue });
    }

    const onClearSearch = () => {
        setSearchValue("");
        setFilters({});
        clearQueryParams();
    }

    const onClearFilters = () => {
        setSearchValue("");
        setFilters({});
        clearQueryParams();
    }

    const updateFilters = (prevFilters: any, columnId: string, value: any) => {
        const updatedFilters = { ...prevFilters };

        if (columnId === "invoiceDate") {
            const { start, end } = value || {};
            if (value === null) {
                setDateRange({ start: null, end: null });
                delete updatedFilters[columnId];
                return JSON.stringify(updatedFilters) === JSON.stringify(prevFilters) ? prevFilters : updatedFilters;
            }
            if (!start || !end || start > end) {
                return JSON.stringify(updatedFilters) === JSON.stringify(prevFilters) ? prevFilters : updatedFilters;
            }
        }

        const handleQuantityFilter = (column: string) => {
            const { option, quantity } = value || {};
            if (!option || quantity < 0) {
                delete updatedFilters[column];
                if (column === "total") setTotal({ option: "", quantity: 0 });
                if (column === "paidAmount") setPaidAmount({ option: "", quantity: 0 });
                if (column === "pendingAmount") setPendingAmount({ option: "", quantity: 0 });
            }
        };

        if (["total", "paidAmount", "pendingAmount"].includes(columnId)) {
            handleQuantityFilter(columnId);
        }

        if (value === null) {
            if (updatedFilters[columnId]) {
                delete updatedFilters[columnId];
            }
        } else {
            updatedFilters[columnId] = value;
        }

        if (Array.isArray(value)) {
            if (value.length === 0) {
                delete updatedFilters[columnId];
            } else {
                updatedFilters[columnId] = value;
            }
        }

        return JSON.stringify(updatedFilters) === JSON.stringify(prevFilters) ? prevFilters : updatedFilters;
    };

    const onFilterChange = (columnId: string, value: any) => {
        setFilters((prevFilters) => {
            const newFilters = updateFilters(prevFilters, columnId, value);
            return newFilters;
        });
    };

    /*
        Lo que cubre la factura, resumido, para no tener que abrirla. Es la razon
        por la que la gente escribe esas notas a mano. (Esteban, 2026-09-16)

            "Mensualidad 3 Gastronomía, Kit de Cejas"
            "Mensualidades 3, 4 y 5 Barbería"
            "2 × Kit de Barbería, Carnet"

        Se apoya en lo que ya manda el servidor: los renglones de la factura traen
        el tipo (TUITION / ARTICLE), el "Mensualidad N" ya armado y el curso.
    */
    const resumenDeConceptos = (invoice: any): string => {
        const renglones: any[] = Array.isArray(invoice?.invoiceItems) ? invoice.invoiceItems : [];

        if (renglones.length < 1) return "";

        const mensualidadesPorCurso: {[curso: string]: string[]} = {};
        const sueltos: string[] = [];
        const articulos: string[] = [];

        renglones.forEach((renglon: any) => {
            if (renglon?.PRODUCT_TYPE === "ARTICLE") {
                const cuantos = Number(renglon.quantity) > 1 ? Number(renglon.quantity) + " × " : "";
                articulos.push(cuantos + String(renglon.name || "").trim());
                return;
            }

            const etiqueta = String(renglon?.monthNumber || renglon?.name || "").trim();
            const curso = cursoCorto(renglon?.courseName);
            const mes = etiqueta.match(/^Mensualidad\s+(\d+)$/i);

            if (mes && curso) {
                if (!mensualidadesPorCurso[curso]) mensualidadesPorCurso[curso] = [];
                mensualidadesPorCurso[curso].push(mes[1]);
                return;
            }

            sueltos.push([etiqueta, curso].filter(Boolean).join(" "));
        });

        const deMensualidades = Object.keys(mensualidadesPorCurso).map((curso) => {
            const meses = mensualidadesPorCurso[curso]
                .sort((a, b) => Number(a) - Number(b));

            if (meses.length === 1) return "Mensualidad " + meses[0] + " " + curso;

            const ultimo = meses[meses.length - 1];

            return "Mensualidades " + meses.slice(0, -1).join(", ") + " y " + ultimo + " " + curso;
        });

        return deMensualidades.concat(sueltos, articulos).filter(Boolean).join(", ");
    };

    const invoiceColumns: Column[] = [
        {
            id: "id",
            header: Constants.Common.id,
            accessor: "id",
            render: (invoice: any) => invoice.id > 0
                ? <ButtonComponent className="wa-btn sm link"
                    tooltip={Constants.Common.invoiceDetail}
                    style={{ opacity: idleLocked ? 0.5 : 1 }}
                    disabled={idleLocked}
                    onClick={() => getInvoiceById(invoice.id)}
                >
                    {invoice.id.toString()}
                </ButtonComponent>
                : "-",
            overrideHeaderStyle: () => ({
                ...styles.tableHeaderStyle
            }),
            overrideCellStyle: (data: any) => ({
                color: data.statusId === invoiceStatus.CANCELLED
                    ? Constants.Styles.text.colors.red
                    : Constants.Styles.text.colors.blackPrimary,
                textAlign: "center",
                width: "66px",
            }),
            filterType: FILTER_TYPES.INPUT_NUMBER,
            defaultFilterValue: filters?.id ?? "",
            filterEnabled: filters?.id > 0
        },
        {
            id: "correlative",
            header: Constants.Common.correlative,
            accessor: "studentIdentityCode",
            filterType: FILTER_TYPES.INPUT_TEXT,
            overrideCellStyle: (data: any) => ({
                color: data.statusId === invoiceStatus.CANCELLED
                    ? Constants.Styles.text.colors.red
                    : Constants.Styles.text.colors.blackPrimary,
                textAlign: "left",
                whiteSpace: "nowrap",
                width: "118px"
            }),
            overrideHeaderStyle: () => ({
                ...styles.tableHeaderStyle
            })
        },
        {
            /*
                "Nombres" y "Apellidos" eran dos columnas de 200px cada una para un
                dato que siempre se lee junto. (Esteban, 2026-09-16)
            */
            id: "firstName",
            header: "Alumno",
            accessor: "",
            render: (invoice: any) =>
                [invoice.studentFirstname, invoice.studentLastname]
                    .filter(Boolean)
                    .join(" "),
            filterType: FILTER_TYPES.INPUT_TEXT,
            overrideCellStyle: (data: any) => ({
                color: data.statusId === invoiceStatus.CANCELLED
                    ? Constants.Styles.text.colors.red
                    : Constants.Styles.text.colors.blackPrimary,
                textAlign: "left",
                whiteSpace: "normal",
                width: "210px"
            }),
            overrideHeaderStyle: () => ({
                ...styles.tableHeaderStyle
            })
        },
        {
            id: "invoiceDate",
            header: Constants.Common.date,
            accessor: "invoiceDate",
            filterType: FILTER_TYPES.DATE_RANGE,
            dateRangeState: {
                start: dateRange.start,
                end: dateRange.end,
                setStart: (date: Date | null) => setDateRange((prev) => ({ ...prev, start: date })),
                setEnd: (date: Date | null) => setDateRange((prev) => ({ ...prev, end: date })),
            },
            overrideCellStyle: (data: any) => ({
                color: data.statusId === invoiceStatus.CANCELLED
                    ? Constants.Styles.text.colors.red
                    : Constants.Styles.text.colors.blackPrimary,
                textAlign: "left",
                whiteSpace: "inherit",
                width: "102px"
            }),
            overrideHeaderStyle: () => ({
                ...styles.tableHeaderStyle
            })
        },
        {
            id: "total",
            header: "Total",
            accessor: "",
            render: (invoice) => `${invoice.currencyCode}${sprintf("%.02f", invoice.total)}`,
            filterType: FILTER_TYPES.AMOUNT_RANGE,
            quantityRangeState: {
                option: total.option,
                setOption: (option: string) => setTotal((prev) => ({ ...prev, option })),
                quantity: total.quantity,
                setQuantity: (quantity: number) => setTotal((prev) => ({ ...prev, quantity })),
            },
            filterOptions: OPERATORS,
            overrideHeaderStyle: () => ({
                ...styles.tableHeaderStyle
            }),
            overrideCellStyle: (data: any) => ({
                color: data.statusId === invoiceStatus.CANCELLED
                    ? Constants.Styles.text.colors.red
                    : Constants.Styles.text.colors.blackPrimary,
                textAlign: "right",
            })
        },
        {
            id: "paidAmount",
            header: "Pagado",
            accessor: "",
            render: (invoice) => `${invoice.currencyCode}${sprintf("%.02f", invoice.paidAmount)}`,
            filterType: FILTER_TYPES.AMOUNT_RANGE,
            quantityRangeState: {
                option: paidAmount.option,
                setOption: (option: string) => setPaidAmount((prev) => ({ ...prev, option })),
                quantity: paidAmount.quantity,
                setQuantity: (quantity: number) => setPaidAmount((prev) => ({ ...prev, quantity })),
            },
            filterOptions: OPERATORS,
            overrideHeaderStyle: () => ({
                ...styles.tableHeaderStyle,
            }),
            overrideCellStyle: (data: any) => ({
                color: data.statusId === invoiceStatus.CANCELLED
                    ? Constants.Styles.text.colors.red
                    : Constants.Styles.text.colors.blackPrimary,
                textAlign: "right",
            })
        },
        {
            id: "pendingAmount",
            header: "Pendiente",
            accessor: "",
            render: (invoice) => `${invoice.currencyCode}${sprintf("%.02f", invoice.pendingAmount)}`,
            filterType: FILTER_TYPES.AMOUNT_RANGE,
            quantityRangeState: {
                option: pendingAmount.option,
                setOption: (option: string) => setPendingAmount((prev) => ({ ...prev, option })),
                quantity: pendingAmount.quantity,
                setQuantity: (quantity: number) => setPendingAmount((prev) => ({ ...prev, quantity })),
            },
            filterOptions: OPERATORS,
            overrideHeaderStyle: () => ({
                ...styles.tableHeaderStyle,
            }),
            overrideCellStyle: (data: any) => ({
                color: data.statusId === invoiceStatus.CANCELLED
                    ? Constants.Styles.text.colors.red
                    : Constants.Styles.text.colors.blackPrimary,
                textAlign: "right",
            })
        },
        {
            id: "status",
            header: Constants.Common.status,
            accessor: "",
            render: (data: any) => <span
                style={{
                    color: data.statusId === invoiceStatus.CANCELLED
                        ? Constants.Styles.text.colors.red
                        : Constants.Styles.text.colors.blackPrimary,
                    font: Constants.Styles.text.fonts.robotoBold16,
                    marginBottom: 0
                }}>
                {data.status}
            </span>,
            filterType: FILTER_TYPES.MULTISELECT,
            filterOptions: invoiceStatuses,
            overrideHeaderStyle: () => ({
                ...styles.tableHeaderStyle,
            }),
        },
        {
            id: "concepts",
            header: "Concepto",
            accessor: "",
            render: (invoice: any) => resumenDeConceptos(invoice),
            overrideCellStyle: (data: any) => ({
                textAlign: "left",
                whiteSpace: "normal",
                overflowWrap: "anywhere",
                minWidth: "215px",
                color: data.statusId === invoiceStatus.CANCELLED
                    ? Constants.Styles.text.colors.red
                    : Constants.Styles.text.colors.blackPrimary,
            }),
            overrideHeaderStyle: () => ({
                ...styles.tableHeaderStyle
            })
        },
        {
            id: "notes",
            header: Constants.Common.notes,
            accessor: "",
            filterType: FILTER_TYPES.INPUT_TEXT,
            /*
                La nota se cortaba a diez caracteres en una columna de 100px
                ("PASTELERIA..."), y es de las cosas que mas se consultan aqui.
                Ahora se lee entera: la columna se queda con el ancho sobrante y el
                texto parte en varias lineas. (Esteban, 2026-09-16)
            */
            render: (invoice: any) => invoice.notes || "",
            overrideCellStyle: (data: any) => ({
                textAlign: "left",
                whiteSpace: "normal",
                overflowWrap: "anywhere",
                minWidth: "230px",
                color: data.statusId === invoiceStatus.CANCELLED
                    ? Constants.Styles.text.colors.red
                    : Constants.Styles.text.colors.blackPrimary,
            }),
            overrideHeaderStyle: () => ({
                ...styles.tableHeaderStyle,
            })
        },
        {
            id: "selectInvoice",
            header: "",
            accessor: "",
            render: () => <React.Fragment></React.Fragment>,
            overrideCellStyle: () => ({
                textAlign: "right",
                borderBottom: 0
            }),
            overrideHeaderStyle: () => ({
                textAlign: "left",
                color: "var(--wa-tinta)"
            })
        }
    ];

    const invoiceColumnsWithLogic = invoiceColumns.map((column: any) => {
        if (column.id === "selectInvoice" && column.render) {
            return {
                ...column,
                /*
                    Era un ojito sin palabra: habia que pasar el cursor por encima
                    para saber que hacia. (Esteban, 2026-09-16)
                */
                render: (invoice: any) => (
                    <button
                        className="waAccionFila"
                        type="button"
                        disabled={idleLocked}
                        onClick={() => getInvoiceById(invoice.id)}
                    >
                        Ver factura
                    </button>
                ),
            };
        }
        return column;
    });

    const handlePageSizeChange = (newPageSize: number) => {
        setItemsPerPage(newPageSize);
    }

    const resetStateData = () => {
        dispatch(setRefundItems(new Set()));
        dispatch(setIsPartialPayment(false));
    }

    const onError = (message: string) => {
        dispatch(displayNotice({
            cornerClose: false,
            message: message,
            heading: <h3 style={{
                color: "var(--wa-rojo-error)",
                display: "inline-block"
            }}>
                Error
            </h3>
        }));
    }

    const getStudentById = async (studentId: number) => {
        try {
            let response = await http.studentService.getStudentById(
                currentCampus.id,
                studentId
            );
            let student = response.data;
            return student;
        } catch (error) {
            console.log(error);
            onError(getErrorMessage(error));
        }
    }

    const setSelectedStudent = async (data: any) => {
        const studentData = await getStudentById(data.studentId);
        dispatch(setStudentData(studentData));
    }

    const fetchRoleData = async () => {
        try {
            const response = await http.roleService.getRoleData(currentRole.id);
            dispatch(setPermissions(response.data.permissions));
            return response.data;
        } catch (err: any) {
            console.error(err);
        }
    }

    const getPaymentMethods = async () => {
        try {
            const response = await http.paymentMethodService
                .getPaymentMethodsByCountry(currentCampus.countryId);
            const paymentMethods = response.data;
            return paymentMethods;
        } catch (err: any) {
            console.error(err);
        }
    }

    const getInvoicesByCampusId = async (page?: number) => {
        try {
            const response = await http.invoiceService.getInvoiceByCampusId(
                userData?.token ?? "",
                currentCampus.id,
                itemsPerPage,
                filters,
                page
            );
            const invoices = response.data;
            return invoices;
        } catch (err: any) {
            console.error(err);
            return [];
        }
    }

    const getPaginatedInvoices = async (url: string) => {
        dispatch(enableIdleLockSwitch())
        try {
            const response = await http.invoiceService.getPaginatedInvoices(
                userData?.token ?? "", url);
            const invoices = response.data;
            updatePaginationInfo(invoices);
            setInvoices(invoices.data);
            return invoices;
        } catch (err: any) {
            console.error(err);
        } finally {
            setIsLoaded(true);
            dispatch(disableIdleLockSwitch());
        }
    }

    const updatePaginationInfo = (pagination: any) => {
        const updatedPages = pagination.links.map((page: any) => ({
            ...page,
            onClick: () => {
                if (page.url) {
                    getPaginatedInvoices(page.url);
                }
            }
        }));
        setItemCount({
            start: pagination.from,
            end: pagination.to,
            total: pagination.total
        });
        setPages(updatedPages);
        setCurrentPage(pagination.current_page);
        recordarPagina(pagination.current_page);
    }

    const showPaymentDetail = async (rowData: any) => {
        try {
            dispatch(enableIdleLockSwitch());
            const response = await dispatch(handleSelectedPayment({
                sessionToken: userData?.token ?? "",
                campusId: currentCampus.id,
                paymentId: rowData.id
            })).unwrap();
            dispatch(setModalContent(FINANCES_MODALS.PAYMENT_DETAIL));

            const payment = {
                ...response.data,
                account: response.data.recipientAccount,
                amount: response.data.amount.value,
                files: response.data.documents
            };
            dispatch(setSelectedPayment(payment));
        } catch (error) {
            onError("Hubo un error al tratar de obtener el documento!");
        }
        finally {
            dispatch(disableIdleLockSwitch());
        }
    }

    const showCreditDetail = async (rowData: any) => {
        try {
            dispatch(enableIdleLockSwitch());
            let response = await dispatch(handleSelectedCredit({
                campusId: currentCampus.id,
                creditId: rowData.id
            })).unwrap();
            const credit = response.data;
            dispatch(setSelectedCredit(credit));
            dispatch(setModalContent(FINANCES_MODALS.APPLY_CREDIT_DETAILS));
            dispatch(setShowModal(true));
        } catch (error) {
            onError("Hubo un error al tratar de obtener el documento!");
        }
        finally {
            dispatch(disableIdleLockSwitch());
        }
    }

    const cancelInvoice = () => {
        dispatch(setModalContent(FINANCES_MODALS.CANCEL_INVOICE));
    }

    const proccessPayment = () => {
        dispatch(setIsPartialPayment(true));
        dispatch(setIsNewInvoice(false));
        dispatch(setModalContent(FINANCES_MODALS.EMIT_PAYMENT));
    }

    const closeModalInvoiceDetail = () => {
        dispatch(setIsPartialPayment(false));
        dispatch(setShowModal(false));
        dispatch(setSelectedInvoice(null));
    }

    const handleCancelPayment = () => {
        setIsCancelPayment(true);
        dispatch(setModalContent(FINANCES_MODALS.CANCEL_PAYMENT))
    }

    const paymentDetailCloseModal = () => {
        dispatch(setModalContent(FINANCES_MODALS.INVOICE))
    }

    const showPaymentUpdateModal = () => {
        dispatch(setModalContent(FINANCES_MODALS.UPDATE_PAYMENT));
    }

    const updatePaymentCloseModal = () => {
        dispatch(setModalContent(FINANCES_MODALS.INVOICE))
    }

    const onSuccessUpdatePayment = () => {
        dispatch(setModalContent(FINANCES_MODALS.UPDATE_PAYMENT));
        showSuccessMessage();
        showPaymentDetail(selectedPayment);
    }

    const showSuccessMessage = () => {
        dispatch(displayNotice({
            cornerClose: false,
            message: "Información procesada con éxito",
            heading: <h3 style={{
                color: "var(--wa-verde)", display: "inline-block"
            }}>
                Listo
            </h3>
        }));
    }

    const cancelPaymentCloseModal = () => {
        setIsCancelPayment(false);
        dispatch(setModalContent(FINANCES_MODALS.PAYMENT_DETAIL));
    }

    const onSuccessCancelPayment = () => {
        fetchData();
        getInvoiceById(selectedInvoice.id);
        dispatch(setShowModal(true));
        showPaymentDetail(selectedPayment);
        showSuccessMessage();
    }

    const cancelEmitPayment = () => {
        if (isPartialPayment && !isNewInvoice) {
            dispatch(setModalContent(FINANCES_MODALS.INVOICE));
        } else {
            dispatch(setModalContent(FINANCES_MODALS.CHECKOUT));
        }
    }

    const showApplyCreditModal = () => {
        dispatch(setModalContent(FINANCES_MODALS.APPLY_CREDIT));
    }

    const onSuccessEmitPayment = () => {
        fetchData();
        getInvoiceById(selectedInvoice.id);
        dispatch(setShowModal(true));
        dispatch(displayNotice({
            cornerClose: false,
            message: "Información procesada con éxito",
            heading: <h3 style={{
                color: "var(--wa-verde)", display: "inline-block"
            }}>
                Listo
            </h3>
        }));
    }

    const closeModalEmitPayment = () => {
        dispatch(setShowModal(false));
    }

    const cancelInvoiceCloseModal = () => {
        dispatch(setModalContent(FINANCES_MODALS.INVOICE));
    }

    const onSuccessCancelInvoice = () => {
        fetchData();
        dispatch(setShowModal(false));
        dispatch(displayNotice({
            cornerClose: false,
            message: "Información procesada con éxito",
            heading: <h3 style={{
                color: "var(--wa-verde)", display: "inline-block"
            }}>
                Listo
            </h3>
        }))
    }

    const generateInvoiceCloseModal = () => {
        dispatch(setModalContent(FINANCES_MODALS.CHECKOUT));
    }

    const onSuccessGeneratePaidInvoice = () => {
        fetchData();
        dispatch(setShowModal(false));
        showSuccessMessage();
    }

    const getQueryParams = () => {
        const query = new URLSearchParams(location.search);
        const data = query.get("data");
        if (!data) {
            return { campusId: 0, invoiceId: 0 };
        }

        try {
            const decodedData = JSON.parse(decodeURIComponent(data));
            return {
                campusId: decodedData?.campus ?? 0,
                invoiceId: decodedData?.invoice ?? 0
            };
        } catch (error) {
            console.error("Error al parsear JSON de query params:", error);
            return { campusId: 0, invoiceId: 0 };
        }
    }

    const clearQueryParams = () => {
        const query = new URLSearchParams(location.search);

        query.forEach((value, key) => {
            query.delete(key);  // delete each parameter
        });

        window.history.replaceState(
            null,
            '',
            `${location.pathname}${location.hash}`  // holding hash, but delete all query params
        );
    }

    const handleCampusChange = (campusId: number) => {
        localStorage.setItem("currentCampus", `C_${campusId}`);
        dispatch(setCurrentUserCampusId(campusId));
        dispatch(setCurrentUserCampus(`C_${campusId}`));
        dispatch(setCurrentCampusId(campusId));
        const newCampus = campuses.find((campus: any) => campus.id === campusId);
        dispatch(setCurrentCampus(newCampus));
    }

    const fetchData = async (page?: number) => {
        resetStateData();
        dispatch(enableIdleLockSwitch());
        if (currentCampus && userData) {
            try {
                const [paymentMethods, invoices] = await Promise.all([
                    getPaymentMethods(),
                    getInvoicesByCampusId(page)
                ]);
                setInvoices(invoices.data);
                updatePaginationInfo(invoices);
                dispatch(disableIdleLockSwitch());
                dispatch(setPaymentMethods(paymentMethods));
                setIsLoaded(true);
            }
            catch (error: any) {
                dispatch(disableIdleLockSwitch());
                if (error.status === 404) {
                    navigate("/students");
                }
                else {
                    console.log(error);
                    onError(getErrorMessage(error));
                }
            }
        }
    }

    const getInvoiceById = async (invoiceId: number) => {
        try {
            dispatch(enableIdleLockSwitch());
            let response = await dispatch(handleSelectedInvoice({
                sessionToken: userData?.token ?? "",
                campusId: currentCampus.id,
                studentId: studentData.id,
                invoiceId
            })).unwrap();
            let invoice = response.data;
            setSelectedStudent(invoice);
            dispatch(setSelectedInvoice(invoice));
            dispatch(setTotalToPaid(invoice.pendingAmount));
            dispatch(setIsNewInvoice(false));
            dispatch(disableIdleLockSwitch());
        } catch (error) {
            onError("Hubo un error al tratar de obtener el documento!");
        }
        finally {
            dispatch(disableIdleLockSwitch());
        }
    }

    const onSuccessApplyCredit = () => {
        fetchData();
        dispatch(setShowModal(false));
        showSuccessMessage();
    }

    const cancelApplyCredit = () => {
        if (isPartialPayment && !isNewInvoice) {
            dispatch(setModalContent(FINANCES_MODALS.INVOICE));
        } else {
            dispatch(setModalContent(FINANCES_MODALS.CHECKOUT));
        }
    }

    const closeModalCancelApplyCredit = () => {
        dispatch(setShowModal(false));
    }

    const creditDetailCloseModal = () => {
        dispatch(setShowModal(false));
    }

    useEffect(() => {
        fetchRoleData();
    }, [currentRole]);

    useEffect(() => {
        if (selectedInvoice && Object.keys(selectedInvoice).length > 0) {
            dispatch(setShowModal(true));
            dispatch(setModalContent(FINANCES_MODALS.INVOICE));
        }
    }, [selectedInvoice]);

    useEffect(() => {
        if (userData?.token && currentCampus !== null) {
            const { campusId, invoiceId } = getQueryParams();
            if (campusId > 0 && invoiceId > 0 && !filtersUpdatedRef.current) {
                //Igual que en pagos: el enlace manda sobre la página recordada.
                olvidarPagina();
                paginaCargadaRef.current = true;
                setCurrentPage(1);
                handleCampusChange(campusId);
                setFilters({ ...filters, "id": invoiceId });
                filtersUpdatedRef.current = true;
                return;
            }
            // Página recordada (utils/paginaRecordada): al volver de un perfil o
            // estado de cuenta se retoma la última página de este módulo y plantel.
            // Cualquier cambio posterior (filtros, plantel, tamaño de página) vuelve a la 1.
            fijarCampusPagina(currentCampus.id);
            const primeraCarga = !paginaCargadaRef.current;
            paginaCargadaRef.current = true;
            if (!primeraCarga) olvidarPagina();
            const pagina = primeraCarga ? paginaRecordada() : 1;
            if (filters?.search === "") {
                setCurrentPage(pagina);
                fetchData(pagina);
                return;
            }
            fetchData(pagina);
        } else {
            onError(
                "No hay planteles registrados o asignados al rol en uso por el usuario, " +
                "por lo que el acceso a este módulo permanecerá deshabilitado."
            )
        }
    }, [userData, currentCampus, itemsPerPage, filters]);

    useEffect(() => {
        if (filters.id) {
            fetchData();
        }
    }, [filters]);

    return !isLoaded || currentCampus === null || userData === null
        ? <React.Fragment></React.Fragment>
        : <InvoiceView
            invoicesProps={{
                invoices,
                tarjetas: invoices.map((invoice: any) => ({
                    clave: invoice.id,
                    titulo: [invoice.studentFirstname, invoice.studentLastname].filter(Boolean).join(" "),
                    subtitulo: resumenDeConceptos(invoice) || invoice.notes || "",
                    chip: {
                        texto: invoice.status,
                        tono: invoice.statusId === invoiceStatus.CANCELLED
                            ? "ambar"
                            : (invoice.pendingAmount > 0 ? "naranja" : "verde")
                    },
                    apagada: invoice.statusId === invoiceStatus.CANCELLED,
                    campos: [
                        { etiqueta: "Factura", valor: "#" + invoice.id },
                        { etiqueta: "Fecha", valor: invoice.invoiceDate },
                        { etiqueta: "Correlativo", valor: invoice.studentIdentityCode },
                        { etiqueta: "Total", valor: invoice.currencyCode + Number(invoice.total ?? 0).toFixed(2) },
                        { etiqueta: "Pagado", valor: invoice.currencyCode + Number(invoice.paidAmount ?? 0).toFixed(2) },
                        { etiqueta: "Pendiente", valor: invoice.currencyCode + Number(invoice.pendingAmount ?? 0).toFixed(2) },
                        { etiqueta: "Notas", valor: invoice.notes, ancho: true }
                    ],
                    acciones: [
                        { texto: "Ver factura", principal: true, disabled: idleLocked, onClick: () => getInvoiceById(invoice.id) }
                    ]
                })),
                columns: invoiceColumnsWithLogic,
                filters,
                onFilterChange,
                onClearFilters
            }}
            paginationProps={{
                pages,
                pagesSize,
                itemCount,
                handlePageSizeChange
            }}
            searchProps={{
                search: searchValue,
                onChangeSearch,
                onClickSearch,
                onClearSearch
            }}
            invoiceDetailProps={{
                cancelInvoice,
                showPaymentDetail,
                showCreditDetail,
                proccessPayment,
                closeModal: closeModalInvoiceDetail
            }}
            emitPaymentProps={{
                isNewInvoice,
                isPartialPayment,
                closeModal: closeModalEmitPayment,
                cancelEmitPayment,
                showApplyCreditModal,
                onSuccess: onSuccessEmitPayment
            }}
            paymentDetailProps={{
                handleCancelPayment,
                showPaymentUpdate: showPaymentUpdateModal,
                closeModal: paymentDetailCloseModal
            }}
            paymentUpdateProps={{
                onSuccess: onSuccessUpdatePayment,
                closeModal: updatePaymentCloseModal
            }}
            cancelPaymentProps={{
                closeModal: cancelPaymentCloseModal,
                onSuccess: onSuccessCancelPayment
            }}
            cancelInvoiceProps={{
                closeModal: cancelInvoiceCloseModal,
                onSuccess: onSuccessCancelInvoice
            }}
            generateInvoiceProps={{
                onSuccess: onSuccessGeneratePaidInvoice,
                closeModal: generateInvoiceCloseModal
            }}
            applyCreditProps={{
                isNewInvoice,
                isPartialPayment,
                closeModal: closeModalCancelApplyCredit,
                cancelApplyCredit,
                onSuccess: onSuccessApplyCredit
            }}
            appliedCreditsDetailProps={{
                closeModal: creditDetailCloseModal,
            }}
        />
}

export default InvoiceController;